import React, { useState, useEffect } from 'react';
import { Typography, Button, Box, Chip } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonIcon from '@mui/icons-material/Person';
import NumberFormat from 'react-number-format';
import { obtenerPresupuestosTotalV } from '../../actions/PresupuestosAction';
import { useStateValue } from '../../contexto/store';

export default function PresupuestosSinProcesarMesVendedor() {
  const [{ sesionUsuario }] = useStateValue();
  const [presupuestosTotal, setPresupuestosTotal] = useState([]);
  
  const actualizarTotales = () => {
    const usuario = sesionUsuario.usuario.id;
    obtenerPresupuestosTotalV(usuario).then(response => {
      const Data = response.data;
      setPresupuestosTotal(Data);
    });
  };

  useEffect(() => {
    const usuario = sesionUsuario.usuario.id;
    obtenerPresupuestosTotalV(usuario).then(response => {
      const Data = response.data;
      setPresupuestosTotal(Data);
    });
  }, [sesionUsuario]);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 0.5 }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1.5,
        mb: 2 
      }}>
        <Box sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #ffa726 0%, #fb8c00 100%)',
          boxShadow: '0 4px 12px rgba(255, 152, 0, 0.3)'
        }}>
          <HourglassEmptyIcon sx={{ color: 'white', fontSize: 28 }} />
        </Box>
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <Chip 
            icon={<PersonIcon />}
            label={sesionUsuario.usuario?.nombrecompleto || ''}
            size="small"
            color="warning"
            variant="outlined"
            sx={{ 
              fontSize: '0.7rem',
              height: 24,
              maxWidth: '100%',
              '& .MuiChip-label': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }
            }}
          />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem', lineHeight: 1.2, mt: 0.5 }}>
            Sin Cerrar
          </Typography>
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', mb: 2 }}>
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 800, 
            color: 'warning.main',
            textAlign: 'left',
            fontSize: { xs: '1.75rem', sm: '2rem' }
          }}
        >
          <NumberFormat
            lang="es"
            notranslate="true"
            value={presupuestosTotal.total}
            displayType="text"
            thousandSeparator={true}
            prefix="₲ "
          />
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Mis presupuestos pendientes
        </Typography>
      </Box>

      <Button 
        variant="outlined" 
        color="warning"
        onClick={actualizarTotales}
        startIcon={<RefreshIcon />}
        size="small"
        sx={{ 
          borderRadius: 1.5,
          textTransform: 'none',
          fontWeight: 600,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            backgroundColor: 'warning.light',
            color: 'white'
          }
        }}
      >
        Actualizar
      </Button>
    </Box>
  );
}
